import React, { useState } from "react";
import "./HeaderStyles.css";


function HeaderLink() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <div className="header-link-container">
      <div className="menu-icon" onClick={toggleMenu}>
        &#9776;
      </div>
      <div className={`header-link ${menuOpen ? "open" : ""}`}>
        <a href="#planes">Planes</a>
        <a href="#cobertura">Cobertura</a>
        <a href="#contactanos">Contáctanos</a>
      </div>
    </div>
  );
}

export default HeaderLink;
